import React, { useEffect, useState, useCallback, useRef } from "react";
import { DataGrid, useGridApiRef } from "@mui/x-data-grid";
import { styled } from "@mui/system";
import { ThemeColor } from "../theme/color";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

import "../datatable/Datatable.css";
import { Box, Button } from "@mui/material";
import { Typography } from "antd";

const StyledDataGrid = styled(DataGrid)({
  "& .MuiTableHead-root": {
    background: ThemeColor.LIGHTPURPLE, // Customize the background color here
    color: "#ffffff", // Optional: customize the text color
  },
});

const columns = [
  { field: "id", headerName: "ID", width: 90 },
  { field: "name", headerName: "Name", width: 150 },
  { field: "age", headerName: "Age", width: 110 },
  // Add more columns as needed
];

const rows = [
  { id: 1, name: "John Doe", age: 35 },
  { id: 2, name: "Jane Smith", age: 42 },
  { id: 3, name: "Jack Johnson", age: 28 },
  // Add more rows as needed
];

function CustomDataTable(props) {
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 2,
  });

  const [selectedRows, setSelectedRows] = useState([]);

  const scrollRef = useRef(null);

  const scroll = (direction) => {
    if (scrollRef.current) {
      const scrollAmount = direction === "left" ? -200 : 200;
      scrollRef.current.scrollBy({ left: scrollAmount, behavior: "smooth" });
    }
  };

  const apiRef = useGridApiRef();

  const handlePaginationChange = (newPaginationModel) => {
    const direction =
      newPaginationModel.page > paginationModel.page ? "right" : "left";
    setPaginationModel(newPaginationModel);
    // //(object);
    if (props?.onPaginationChange)
      props?.onPaginationChange(newPaginationModel, direction);
  };

  // Notify parent of visible columns
  const notifyVisibleColumns = useCallback(() => {
    if (apiRef.current) {
      const visibleColumns = apiRef.current
        .getVisibleColumns()
        .map((col) => col.field);
      console.log("Initial Visible Columns in Child:", visibleColumns);
      props.onVisibleColumnsChange?.(visibleColumns);
    }
  }, [apiRef, props.onVisibleColumnsChange]);

  const handleColumnVisibilityChange = useCallback(() => {
    if (apiRef.current) {
      const visibleColumns = apiRef.current
        .getVisibleColumns()
        .map((col) => col.field);
      props?.onVisibleColumnsChange?.(visibleColumns);
    }
  }, [apiRef, props.onVisibleColumnsChange]);

  useEffect(() => {
    notifyVisibleColumns();
  }, []);

  return (
    <div
      className="custom-scroll table-wrapper"
      style={{
        height: props?.height ? props?.height : "100%",
        width: "100%",
        position: "relative",
      }}
    >
      <Typography
        style={{
          margin: "0 0 8px",
          fontSize: "0.8rem",
          color: "#64748B",
        }}
      >
        {selectedRows.length ? selectedRows.length : "No"} row(s) selected
      </Typography>

      {/* The grid owns horizontal scrolling; this wrapper just bounds it. */}
      <div
        className="table-inner"
        style={{
          minWidth: props?.minTableWidth || "100%",
          // `70vh` was hardcoded, so a table inside a modal ignored the height
          // it was given and overflowed its container.
          height: props?.tableHeight || "70vh",
        }}
        ref={scrollRef}
      >
        <StyledDataGrid
          apiRef={apiRef}
          rows={props.row ? props.row : rows}
          columns={props.columns ? props.columns : columns}
          loading={props.loading}
          hideFooter
          paginationMode="server"
          rowCount={props.totalCount || props.rowCount || (props.row ? props.row.length : rows.length)}
          componentsProps={{
            columnMenu: {
              sx: {
                "& .MuiDataGrid-menuIconButton": {
                  color: "red", // Change icon color here
                },
              },
            },
          }}
          sx={{
            width: "100%",
            "& .MuiDataGrid-columnHeader": {
              position: "sticky",
              top: 0,
              zIndex: 1000,
              background: ThemeColor.BLUE,
              color: ThemeColor.WHITE,
            },
            "& .MuiDataGrid-panelFooter": {
              background: "yellow",
            },
            "& .MuiDataGrid-main": {
              overflow: "scroll",
              "& ::-webkit-scrollbar": {
                width: "5px", // Scrollbar width
                height: "10px", // Horizontal scrollbar height
              },
              "& ::-webkit-scrollbar-thumb": {
                backgroundColor: "#000000", // Scrollbar color
                borderRadius: "4px", // Rounded scrollbar
              },
              "& ::-webkit-scrollbar-thumb:hover": {
                backgroundColor: "#000000", // On hover
              },
              "& ::-webkit-scrollbar-track": {
                backgroundColor: "#ffffff", // Track color
              },
            },
            "& .MuiDataGrid-cell": {
              py: 0.5,
              fontSize: "0.85rem",
            },
            "& .MuiDataGrid-row": {
              height: 26,
            },
          }}
          
          pageSizeOptions={[25, 50, 100]}
          checkboxSelection
          onSelectionModelChange={props.onSelectionModelChange}
          disableRowSelectionOnClick
          stickyHeader
          rowHeight={50}
          getRowClassName={props.getRowClassName}
          onRowSelectionModelChange={(newSelection) => {
            setSelectedRows(newSelection);
            props.onSelectionChange?.(newSelection); // keep your handler if needed
          }}
          paginationModel={paginationModel}
          onPaginationModelChange={handlePaginationChange}
          onColumnVisibilityModelChange={handleColumnVisibilityChange}
        />
     


    </div>
    </div>
  );
}

export default CustomDataTable;
